import { render, staticRenderFns } from "./panel2.vue?vue&type=template&id=52c1d1c4&scoped=true&"
import script from "./panel2.vue?vue&type=script&lang=js&"
export * from "./panel2.vue?vue&type=script&lang=js&"
import style0 from "./panel2.vue?vue&type=style&index=0&id=52c1d1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1d1c4",
  null
  
)

export default component.exports